import {
	apiGet,
	type ErrorResponse,
	type FetchResponse,
	getApiUrl,
} from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import type { PartnerAllocationHistoryItem } from "Order/Utilities/partnerAllocationHistory";
import { useQuery } from "@tanstack/react-query";

export const ORDER_PARTNER_ALLOCATIONS = "ORDER_PARTNER_ALLOCATIONS";

export const getOrderPartnerAllocationsQueryKey = (orderId: number) => [
	ORDER_PARTNER_ALLOCATIONS,
	orderId,
];

export type GetOrderPartnerAllocationsFetchResponse =
	| FetchResponse<PartnerAllocationHistoryItem[], 200>
	| ErrorResponse;

export const getOrderPartnerAllocationsPath = (orderId: number) =>
	`/orders/${orderId}/partner-allocations`;

export const getOrderPartnerAllocations = (
	orderId: number,
	headers = new Headers(),
): Promise<GetOrderPartnerAllocationsFetchResponse> => {
	return apiGet(
		`${getApiUrl()}${getOrderPartnerAllocationsPath(orderId)}`,
		headers,
		{},
	) as Promise<GetOrderPartnerAllocationsFetchResponse>;
};

export function useOrderPartnerAllocationsQuery(orderId: number) {
	return useQuery({
		queryKey: getOrderPartnerAllocationsQueryKey(orderId),
		queryFn: processResponse(() => getOrderPartnerAllocations(orderId)),
		retry: false,
		refetchInterval: false,
		refetchIntervalInBackground: false,
		enabled: !!orderId,
	});
}
